export default "__VITE_ASSET__jchyDn6v__"